module.exports = __webpack_public_path__ + "img/aj.c9ab0b8a.jpg";